module.exports = __webpack_public_path__ + "img/yinying.89113851.png";